export default "__VITE_ASSET__izE$kpc0__"